import React from "react";
import { RootState } from "@src/reducers/store";
import { useSelector } from "react-redux";
import { EditUserDrawerModal } from "@src/components/organisms/modals/edit-user-drawer-modal/edit-user-drawer-modal";

export const EditUserDrawer = () => {
  const showEditUserDrawerModal = useSelector(
    (state: RootState) => state.yourSlice.modals.editUserDrawerModal.showModal,
  );

  return <>{showEditUserDrawerModal && <EditUserDrawerModal />}</>;
};
